import { InvoiceType } from '__generated__/GQL';
import GeneralContent from 'features/Work/components/FormSectionsContent/GeneralContent';

import { useQuoteFormContext } from '../../../context';

const General = () => {
  const { clients, companySettings } = useQuoteFormContext();

  return (
    <GeneralContent
      clients={clients}
      companyLogoUrl={companySettings?.logoUrl}
      type={InvoiceType.Quote}
    />
  );
};

export default General;
